// This file is generated automatically
// Don't edit this file directly

import { call, toParams } from './utils'

export let api_origin = '/api'

// GET /api/credit/top-up/packages
export function getTopUpPackages(input: GetTopUpPackagesInput): Promise<GetTopUpPackagesOutput & { error?: string }> {
  return call('GET', api_origin + `/credit/top-up/packages`)
}
export type GetTopUpPackagesInput = {
}
export type GetTopUpPackagesOutput = {
  packages: Array<{
    package_id: number
    title_en: string
    title_zh_cn: string
    title_zh_hk: string
    fee: number
    credits: number
    cancel_time: null | number
  }>
}

// GET /api/credit/subscription/plans
export function getSubscriptionPlans(input: GetSubscriptionPlansInput): Promise<GetSubscriptionPlansOutput & { error?: string }> {
  return call('GET', api_origin + `/credit/subscription/plans`)
}
export type GetSubscriptionPlansInput = {
}
export type GetSubscriptionPlansOutput = {
  plans: Array<{
    id: number
    title_en: string
    title_zh_cn: string
    title_zh_hk: string
    hkd: number
    credits: number
    cancel_time: null | number
    subscriptions: Array<{
      id: number
      status: null | string
      credit_used: number
      cancel_at: null | number
      effective_subscription_plan_id: null | number
    }>
  }>
}

// POST /api/credit/top_up
export function topUpCredit(input: TopUpCreditInput): Promise<TopUpCreditOutput & { error?: string }> {
  return call('POST', api_origin + `/credit/top_up`, input.body)
}
export type TopUpCreditInput = {
  body: {
    package_id: number
  }
}
export type TopUpCreditOutput = {
  url: string
}

// POST /api/credit/subscription
export function subscribeCredit(input: SubscribeCreditInput): Promise<SubscribeCreditOutput & { error?: string }> {
  return call('POST', api_origin + `/credit/subscription`, input.body)
}
export type SubscribeCreditInput = {
  body: {
    plan_id: number
  }
}
export type SubscribeCreditOutput = {
  url: string
}

// GET /api/credit/top_up/:top_up_id/_ingest
export function _topUpCreditIngest(input: _topUpCreditIngestInput): Promise<_topUpCreditIngestOutput & { error?: string }> {
  let { params } = input
  return call('GET', api_origin + `/credit/top_up/${params.top_up_id}/_ingest`)
}
export type _topUpCreditIngestInput = {
  params: {
    top_up_id: number
  }
}
export type _topUpCreditIngestOutput = {
}

// GET /api/credit/subscription/:subscription_id/_ingest
export function _subscriptionCreditIngest(input: _subscriptionCreditIngestInput): Promise<_subscriptionCreditIngestOutput & { error?: string }> {
  let { params } = input
  return call('GET', api_origin + `/credit/subscription/${params.subscription_id}/_ingest`)
}
export type _subscriptionCreditIngestInput = {
  params: {
    subscription_id: number
  }
}
export type _subscriptionCreditIngestOutput = {
}

// GET /api/credit/subscription/:subscription_id/change-plan/:plan_id/_ingest
export function _subscriptionUpdateCreditIngest(input: _subscriptionUpdateCreditIngestInput): Promise<_subscriptionUpdateCreditIngestOutput & { error?: string }> {
  let { params } = input
  return call('GET', api_origin + `/credit/subscription/${params.subscription_id}/change-plan/${params.plan_id}/_ingest`)
}
export type _subscriptionUpdateCreditIngestInput = {
  params: {
    subscription_id: number
    plan_id: number
  }
}
export type _subscriptionUpdateCreditIngestOutput = {
}

// GET /api/credit/top_up/:top_up_id/status
export function topUpCreditStatus(input: TopUpCreditStatusInput): Promise<TopUpCreditStatusOutput & { error?: string }> {
  let { params } = input
  return call('GET', api_origin + `/credit/top_up/${params.top_up_id}/status`)
}
export type TopUpCreditStatusInput = {
  params: {
    top_up_id: number
  }
}
export type TopUpCreditStatusOutput = {
  top_up_status: string
}

// GET /api/credit/subscription/:subscription_id/status
export function subscriptionStatus(input: SubscriptionStatusInput): Promise<SubscriptionStatusOutput & { error?: string }> {
  let { params } = input
  return call('GET', api_origin + `/credit/subscription/${params.subscription_id}/status`)
}
export type SubscriptionStatusInput = {
  params: {
    subscription_id: number
  }
}
export type SubscriptionStatusOutput = {
  subscription_status: string
  error: null | string
}

// DELETE /api/credit/subscription/:subscription_id/cancel
export function cancelSubscription(input: CancelSubscriptionInput): Promise<CancelSubscriptionOutput & { error?: string }> {
  let { params } = input
  return call('DELETE', api_origin + `/credit/subscription/${params.subscription_id}/cancel`)
}
export type CancelSubscriptionInput = {
  params: {
    subscription_id: number
  }
}
export type CancelSubscriptionOutput = {
}

// PATCH /api/credit/subscription/:subscription_id/resume
export function resumeSubscription(input: ResumeSubscriptionInput): Promise<ResumeSubscriptionOutput & { error?: string }> {
  let { params } = input
  return call('PATCH', api_origin + `/credit/subscription/${params.subscription_id}/resume`)
}
export type ResumeSubscriptionInput = {
  params: {
    subscription_id: number
  }
}
export type ResumeSubscriptionOutput = {
}

// PATCH /api/credit/subscription/:subscription_id/change-plan/:plan_id
export function changeSubscriptionPlan(input: ChangeSubscriptionPlanInput): Promise<ChangeSubscriptionPlanOutput & { error?: string }> {
  let { params } = input
  return call('PATCH', api_origin + `/credit/subscription/${params.subscription_id}/change-plan/${params.plan_id}`)
}
export type ChangeSubscriptionPlanInput = {
  params: {
    plan_id: number
    subscription_id: number
  }
}
export type ChangeSubscriptionPlanOutput = {
  url: string
}
